<template>
  <div class="showcase-home">
    <ShowcaseHomeHero />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import ShowcaseHomeHero from '@/showcase/home/components/showcase-home-hero';

export default defineComponent({
  name: 'ShowcaseHome',

  /**
   * 标题
   */
  title() {
    return '前台';
  },

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentStepName: 'invite/currentStepName',
    }),
  },

  /**
   * 已创建
   */
  async created() {
    //
    this.setLayout('ShowcaseLayout');

    const { step } = this.$route.query;
    const isValidStep = await this.verifySteps(step);

    if (isValidStep) {
      this.setCurrentStepName(step);
    } else {
      this.setCurrentStepName('initial');

      let query = Object.assign({}, this.$route.query);

      delete query.step;

      this.$router.replace({
        name: this.$route.name,
        query,
      });
    }
  },

  /**
   * 监视
   */
  watch: {
    async currentStepName(newValue) {
      const { step } = this.$route.query;
      const isValidStep = await this.verifySteps(newValue);

      if (isValidStep && !(newValue === step)) {
        if (newValue === 'initial') {
          let query = Object.assign({}, this.$route.query);
          delete query.step;

          this.$router.push({
            name: this.$route.name,
            query,
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              ...this.$route.query,
              step: newValue,
            },
          });
        }
      }
    },
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setLayout: 'layout/setLayout',
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    ...mapActions({
      verifySteps: 'invite/verifySteps',
    }),
  },

  /**
   * 使用组件
   */
  components: {
    ShowcaseHomeHero,
  },
});
</script>

<style scoped>
@import './styles/showcase-home.css';
</style>
